// @flow
import { connect } from "react-redux";
import FeedbackDialog from "./view";
import Dialog from "../dialog";
import { hideDialog } from "../state/context/actions";
import { isDialogOpen } from "../state/context/reducer";

export default connect(
    state => ({
        open: isDialogOpen(state, "feedback"),
        Dialog
    }),
    dispatch => ({
        onHide: () => dispatch(hideDialog("feedback"))
    })
)(FeedbackDialog);



// WEBPACK FOOTER //
// ./src/feedback-dialog/index.js